import {
  CLEAR_MANUFACTURERS,
  FETCH_MANUFACTURER,
  FETCH_MANUFACTURER_FULFILLED,
  FETCH_MANUFACTURER_REJECTED,
} from 'b2b-apps/shop/manufacturer/redux/manufacturer/actionTypes';
import {
  ClearManufacturersAction,
  FetchManufacturerAction,
  FetchManufacturerFulfilledAction,
  FetchManufacturerRejectedAction,
  ManufacturerType,
} from 'b2b-apps/shop/manufacturer/redux/manufacturer/types';

const clearManufacturers = (): ClearManufacturersAction => ({
  type: CLEAR_MANUFACTURERS,
});

const fetchManufacturer = (
  manufacturerId: string,
): FetchManufacturerAction => ({
  type: FETCH_MANUFACTURER,
  payload: {
    manufacturerId,
  },
});

const fetchManufacturerFulfilled = (
  manufacturerId: string,
  response: ManufacturerType,
): FetchManufacturerFulfilledAction => ({
  type: FETCH_MANUFACTURER_FULFILLED,
  payload: {
    data: response,
    manufacturerId,
  },
});

const fetchManufacturerRejected = (
  manufacturerId: string,
  error: ErrorType,
): FetchManufacturerRejectedAction => ({
  type: FETCH_MANUFACTURER_REJECTED,
  payload: {
    error,
    manufacturerId,
  },
});

export {
  clearManufacturers,
  fetchManufacturer,
  fetchManufacturerFulfilled,
  fetchManufacturerRejected,
};
